import { Navbar } from '@/components/Navbar';
import { HeroSection } from '@/components/HeroSection';
import { AboutSection } from '@/components/AboutSection';
import { DestinationsSection } from '@/components/DestinationsSection';
import { ServicesSection } from '@/components/ServicesSection';
import { TestimonialsSection } from '@/components/TestimonialsSection';
import { ContactSection } from '@/components/ContactSection';
import { Footer } from '@/components/Footer';
import { Toaster } from '@/components/ui/sonner';

import SEO from '@/components/SEO';

const HomePage = () => {
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Peregrine Tours & Safaris",
    "url": "https://www.peregrinetoursandsafaris.com",
    "logo": "https://www.peregrinetoursandsafaris.com/images/logo.png",
    "description": "Discover the Wild Heart of Africa with Peregrine Tours. Expert-guided safaris in Victoria Falls, Chobe, Hwange, and more.",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+260 771343714",
      "contactType": "customer service",
      "availableLanguage": ["English"]
    },
    "sameAs": [
      "https://www.facebook.com/peregrinetoursandsafaris",
      "https://www.instagram.com/peregrinetoursandsafaris"
    ]
  };

  const businessSchema = {
    "@context": "https://schema.org",
    "@type": "TravelAgency",
    "name": "Peregrine Tours & Safaris",
    "image": "https://www.peregrinetoursandsafaris.com/images/safari.webp",
    "@id": "https://www.peregrinetoursandsafaris.com",
    "url": "https://www.peregrinetoursandsafaris.com",
    "telephone": "+260 771343714",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Livingstone",
      "addressLocality": "Livingstone",
      "addressCountry": "ZM"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": -17.8447,
      "longitude": 25.8559
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday"
      ],
      "opens": "00:00",
      "closes": "23:59"
    }
  };

  return (
    <div className="min-h-screen">
      <SEO
        title="Home"
        description="Discover the Wild Heart of Africa with Peregrine Tours. Expert-guided safaris in Victoria Falls, Chobe, Hwange, and more."
        keywords="African Safari, Victoria Falls Tours, Chobe Safari, Hwange National Park, Adventure Travel, Luxury Safari"
        canonicalUrl="https://www.peregrinetoursandsafaris.com/"
        schema={[homeSchema, businessSchema]}
      />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <DestinationsSection />
      <ServicesSection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
};


export default HomePage;